import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { SiteComponent } from './site.component';
import { HomeComponent } from './pages/home/home.component';
import { EmpresaComponent } from './pages/empresa/empresa.component';
import { PropositoComponent } from './pages/proposito/proposito.component';
import { HistoriaComponent } from './pages/historia/historia.component';
import { ContatoComponent } from './pages/contato/contato.component';
import { VestuarioComponent } from './pages/vestuario/vestuario.component';
import { Projeto50Component } from './pages/projeto50/projeto50.component';
import { CollabsComponent } from './pages/collabs/collabs.component';
import { FocushomeComponent } from './pages/focushome/focushome.component';
import { AcessoriosComponent } from './pages/acessorios/acessorios.component';
import { SustentavelComponent } from './pages/sustentavel/sustentavel.component';
import { LoginComponent } from './pages/login/login.component';
import { CadastroComponent } from './pages/cadastro/cadastro.component';
import { FocusAppStoreComponent } from './pages/focusappstore/focusappstore.component';
import {  DownloadComponent } from './pages/downloadApp/download.component';
import { AppIfairQAComponent } from './pages/app-qa/app-ifair-qa.component';


const routes: Routes = [
  {
    path: '',
    component: SiteComponent,
    children: [
      { path: 'site', component: HomeComponent },
      { path: 'empresa', component: EmpresaComponent },
      { path: 'proposito', component: PropositoComponent },
      { path: 'historia', component: HistoriaComponent },
      { path: 'contato', component: ContatoComponent },
      { path: 'vestuario', component: VestuarioComponent },
      { path: 'projeto-50', component: Projeto50Component },
      { path: 'collabs', component: CollabsComponent },
      { path: 'login', component: LoginComponent },
      { path: 'cadastro', component: CadastroComponent },
      { path: 'focushome', component: FocushomeComponent },
      { path: 'acessorios', component: AcessoriosComponent },
      { path: 'sustentavel', component: SustentavelComponent },
      { path: '', redirectTo: '/site', pathMatch: 'full' },
      {path: 'appstore', component: FocusAppStoreComponent},
      { path: 'download', component: DownloadComponent }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class SiteRoutingModule { }
